import * as React from 'react';
import { useState } from 'react';
import { setIsDirty, isDirty, getSelector } from '../../redux/MiscSlice';
import { Button, Input, Row, Col, Label } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { useHistory } from 'react-router-dom';
import { selectUser } from '../../redux/UserSlice';
import { getReportingUnitsHierarchy, resetEntitiesState, getAllEntities } from '../../redux/EntitiesSlice';
import { resetConceptState, ConceptRef, Concept } from "../../redux/ConceptSlice";
import { resetTaxonomyConceptState, loadTaxonomyConcept, getSelectedTaxonomyConcept, setSelectedTaxonomyConcept } from "../../redux/TaxonomyConceptSlice";
import { loadAllPartDefinitions, loadAllReferenceRoles, clearSelectedReference, loadAllTaxonomyReferences, resetReferenceState } from "../../redux/TaxonomyReferenceSlice";
import { NetworkConceptsFilter, loadAllAccounts, resetAccountsState } from '../../redux/AccountsSlice';
import { Prompt } from "react-router-dom";
import { ActiveTaxonomyVersionInfo, TaxonomyVersionInfo, selectCurrentVersion, setTaxonomyVersion, isTaxonomyDirty, selectAvailableVersions, getAllTaxonomyVersions, TaxonomyTypeEnum, VersionRef, getReferenceForVersion, getReferenceForBasicVersion } from '../../redux/TaxonomyVersionSlice';
import { TaxonomyChangesState, TaxonomyUpdateReport, getTaxonomyChanges, anyChanges, commitChanges, clearChanges, setTaxonomyChangeVersion } from '../../redux/TaxonomyChangesSlice';
import { loadEvents } from '../../redux/EventsSlice';
import utilityHelper from '../../utils/utilityHelper';
import { loadDefinitionNetworks } from '../../redux/NetworkSlice';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const TaxonomyVersionSelector = (props: { taxonomyType: TaxonomyTypeEnum }) => {
    const history = useHistory();
    const user = useAppSelector(selectUser);
    const selectedVersion: ActiveTaxonomyVersionInfo | null = useAppSelector(selectCurrentVersion);
    const changes: TaxonomyChangesState | null = useAppSelector(getTaxonomyChanges);
    const isDirtyInfo: boolean = useAppSelector(isDirty);
    const isTaxonomyDirtyInfo: boolean = useAppSelector(isTaxonomyDirty);
    const userRole = user && user.userProfile ? user.userProfile.role : "ENTITY_USER";

    const dispatch = useAppDispatch();

    const [versions,setVersions] = useState<Array<TaxonomyVersionInfo>>(useAppSelector(selectAvailableVersions));
    const [taxonomyIsDirty, setTaxonomyIsDirty] = useState(anyChanges(changes));

    React.useEffect(() => {
        var taxTypes = "AFR";
        switch (props.taxonomyType) {
            case TaxonomyTypeEnum.AFR:
                taxTypes = "AFR,BASE";
                break;

            case TaxonomyTypeEnum.COURT_REPORTING:
            case TaxonomyTypeEnum.COURT_REPORTING_939:
            case TaxonomyTypeEnum.COURT_REPORTING_29:
                taxTypes = "COURT_REPORTING,COURT_REPORTING_939,COURT_REPORTING_29";
                break;
        }
        dispatch(getAllTaxonomyVersions(taxTypes)).then((result: any) => {
            var vList: TaxonomyVersionInfo[] | null = result.payload;
            if (vList) {
                setVersions(vList);
            }
            if (vList && vList.length > 0) {
                setVersion(getVersionId(vList[0]));
            }
        });
    }, [])

    React.useEffect(() => {
        setTaxonomyIsDirty(anyChanges(changes));
    }, [isTaxonomyDirtyInfo,changes])

    const selectedYear = selectedVersion ? selectedVersion.year : 0;
    /*
    if (props.publicreports && afrs && afrs.length > 0) {
        afrs = afrs.filter(a => a.status === "VERIFIED");
    }
     */
    const [values, setValues] = useState<VersionRef>(getReferenceForVersion(selectedVersion, -1));

    React.useEffect(() => {
        setValues(getReferenceForVersion(selectedVersion, -1));
    }, [selectedVersion])
    function properCase(src : string) {
        var dStatus = src.split("_");
        return dStatus.map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()).join(" ");
    }
    const getVersionId = function (v: TaxonomyVersionInfo |null): VersionRef {
        return getReferenceForBasicVersion(v,-1);
    }
    const setVersion = function (versionId: VersionRef) {
        setValues(versionId);

        var tvInfo: ActiveTaxonomyVersionInfo | null = null;
        for (var v of versions) {
            if (v.year === versionId.year && v.type === versionId.type) {
                tvInfo = {
                    year: v.year,
                    type: v.type,
                    periods: v.periods,
                    id: utilityHelper.generateGuid(),
                    isPublished: true
                };
            }
        }
        if (tvInfo) {
            var vRef: VersionRef = getReferenceForVersion(tvInfo,-1);
            // We create a new version object, even though its the same year, to trigger the same UI events as a switch in versions 
            dispatch(clearSelectedReference());
            dispatch(setTaxonomyVersion(tvInfo));
            //dispatch(clearChanges());
            dispatch(setTaxonomyChangeVersion(vRef));
            dispatch(getAllEntities());
            dispatch(loadAllReferenceRoles(vRef));
            dispatch(loadAllTaxonomyReferences(vRef));
            dispatch(loadAllPartDefinitions(vRef));
            dispatch(getReportingUnitsHierarchy(vRef));
            dispatch(loadDefinitionNetworks(tvInfo));
            var accountQuery: NetworkConceptsFilter = {
                nameFilter: "*Title+",
                taxonomyVersion: vRef
            }
            //console.log("new filter: " + JSON.stringify(accountQuery));

            dispatch(loadAllAccounts(accountQuery));
        } else {
            dispatch(clearChanges());
            dispatch(clearSelectedReference());
            dispatch(resetReferenceState());
            dispatch(resetAccountsState());
        }
    }
    //TODO change data binding to use entities slice
    const onChangeValue = (event: any) => {
        var parts: string[] = event.target.value.split("^");
        var tt = TaxonomyTypeEnum.AFR;
        if (parts.length > 1) {
            switch (parts[1]) {
                case "COURT_REPORTING":
                    tt = TaxonomyTypeEnum.COURT_REPORTING;
                    break;
                case "COURT_REPORTING_939":
                    tt = TaxonomyTypeEnum.COURT_REPORTING_939;
                    break;
                case "COURT_REPORTING_29":
                    tt = TaxonomyTypeEnum.COURT_REPORTING_29;
                    break;
                case "BASE":
                    tt = TaxonomyTypeEnum.BASE;
                    break;
            }
        }
        var yr = parseInt(parts[0]);
        var selV: VersionRef = {
            year: yr,
            type: tt
        };
        setVersion(selV);
        dispatch(resetTaxonomyConceptState());
    }

    const handleSaveClick = () => {
        if (selectedVersion) {


            /* get the most updated Afr reference */
            const currentChanges: TaxonomyChangesState = dispatch(getSelector(getTaxonomyChanges));
            if (!anyChanges(currentChanges)) {
                console.log("what?");
                return;
            }
//            var selAccount: Concept | null = dispatch(getSelector(getSelectedTaxonomyConcept));
            dispatch(commitChanges(currentChanges))
                .then((result: any) => {
                    // Now set the version as though we had changed the version - which should trigger refreshes where needed
                    setVersion(getVersionId(selectedVersion));
                    var report: TaxonomyUpdateReport = result.payload as TaxonomyUpdateReport;
                    if (report && report.success === false) {
                        Swal.fire(utilityHelper.importFailedNotFinished('<ul style="text-align:left">' + report.report + "</ul>"));
                    } else {
                        dispatch(clearChanges());
                        dispatch(resetConceptState({}));
                        //            if (selAccount) {
                        //                var ref: ConceptRef = {
                        //                    conceptId: "AccountCode_" + selAccount.id,
                        //                    afrYear: selectedVersion.year
                        //                }
                        //                dispatch(loadTaxonomyConcept(ref));
                        //            }
                        dispatch(clearSelectedReference());
                        //reset the dirty flag
                        dispatch(setIsDirty({ IsDirty: false, Page: "" }));
                        setVersion(values);
                        Swal.fire('Taxonomy changes saved!', '', 'info');
                    }
                });

        }
    }
    
    const handleUndoClick = () => {
        if (selectedVersion) {

            Swal.fire({
                title: '<b>Are you sure?</b>',
                html: "There are unsaved changes to your Taxonomy. Do you want to <b>discard</b> your changes? <br/> You won't be able to revert this!",
                icon: 'warning',
                allowOutsideClick: false,
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonColor: '#3085d6',
                denyButtonColor: '#28a745',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, discard it!',
                cancelButtonText: 'No, cancel!',
                denyButtonText: 'Save and Close!',
                reverseButtons: true
            }).then((result : any) => {
                if (result.isConfirmed) {

                    // rollback changes
                    dispatch(clearChanges());
                    dispatch(resetConceptState({}));
                    setVersion(values);
                    //reset the dirty flag so the save/undo buttons disappear
                    dispatch(setIsDirty({ IsDirty: false, Page: "" }));

                } /* Save and Close */
                else if (result.isDenied) {

//                    var commitCall = {
//                        currentAfr: selected,
//                        changedVersionStates: stateChanges,
//                        submit: false
//                    }
//                    dispatch(commitAfr(commitCall));
                    dispatch(resetConceptState({}));
                    //reset the dirty flag
                    dispatch(setIsDirty({ IsDirty: false, Page: "" }));

                    Swal.fire('Changes saved!', '', 'info');
                }

            });

        }
    }

    const taxonomyChanged = function () {

        if (selectedVersion) {
            return selectedVersion.year;
        }
        return null;
    }



    return (
        <React.Fragment>

            {
                versions ?
                    (<div onChange={onChangeValue}>
                        <ul>
                            {versions.map((v) => (
                                <li key={v.year + " => " + v.type} >
                                    <Input type="radio"
                                        value={v.year + "^" + v.type}
                                        name="taxonomychooser"
                                        onChange={onChangeValue}
                                        disabled={isDirtyInfo}
                                        checked={v.year === values.year && values.type === v.type}
                                    />
                                    {(v.type === "AFR") ? v.year + " AFR" : utilityHelper.toTitleCase(v.type)}

                                </li>
                            ))}
                        </ul>

                        {
                            selectedVersion ?
                                (<div onChange={onChangeValue}>
                                    {taxonomyIsDirty
                                        && <Button type="button" onClick={handleSaveClick}>Save</Button>}
                                    {taxonomyIsDirty && '  '}
                                    {taxonomyIsDirty
                                        && <Button type="button" onClick={handleUndoClick}>Undo</Button>}

                                </div>)
                                :
                                (<div></div>)

                        }


                    </div>
                    )
                    :
                    (<div></div>)

            }
        </React.Fragment>
    )
}

export default TaxonomyVersionSelector;